import React from "react"
/* custom component */
import Header from "../../../component/Header/Header"
import { PageContainer, LayoutContainer } from "../../../component/Xcomponent"
import BulkUpload from "../../../component/BulkUpload/BulkUpload"

/* actions */

/* otehrs */

export const SampleMasterBulkUpload = props => {
    /* variables */
    return (
        <>
            <Header
                backButton={"/sample-master/list"}
                title={"Sample Master Bulk Upload"}
            />
            <PageContainer>
                <LayoutContainer>
                    <BulkUpload master="sampleMaster" backUrl="/sample-master/list" apiUrl="sample/bulk-upload" />
                </LayoutContainer>
            </PageContainer>
        </>
    )
}

export default SampleMasterBulkUpload;